module.exports = __webpack_public_path__ + "img/trash-alt.d150be80.svg";